var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4997 4.16634L13.9684 5.63509L8.15592 11.458L20.833 11.458V13.5413L8.15592 13.5413L13.9788 19.3538L12.4997 20.833L4.16634 12.4997L12.4997 4.16634Z","fill":"#2E75D8"}));
}

ArrowLeft.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
